import { useCallback, useMemo } from 'react';
import type { SessionSource } from '@/store/SessionStore';
import type { ActivityType, TagParams } from './types';
import { deriveFlowTag, getClubCode, loadUtagJs } from './utils';

const useTagging = () => {
  const clubcode = useMemo(() => getClubCode(), []);

  const commonTags = useMemo(
    () => ({
      channel: 'travel',
      clubcode,
      subchannel1: 'scheduler',
    }),
    [clubcode],
  );

  const maxRetryCount = 5;

  const tag = useCallback(
    async (
      activityType: ActivityType,
      sessionSource: SessionSource,
      tags: TagParams,
      retryCount = 0,
    ) => {
      if (retryCount > maxRetryCount) {
        return;
      }

      const lowercaseDestination = (tags.trv_end_location || '').toLowerCase();
      const lowercaseCommPref = tags.comm_pref?.toLowerCase();

      const page = tags.page;

      window.aceMediaTagValues = {
        ...commonTags,
        ...tags,
        ...(lowercaseCommPref ? { comm_pref: lowercaseCommPref } : {}),
        page,
        trv_end_location: lowercaseDestination,
        flow: deriveFlowTag(sessionSource, tags.flow),
      };

      if (!window.utag) {
        loadUtagJs();
      } else {
        window.utag[activityType](window.aceMediaTagValues);
      }
    },
    [commonTags],
  );

  return { tag };
};

export default useTagging;
